<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="镇">
        <el-input v-model="queryInfo.town" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="村">
        <el-input v-model="queryInfo.village" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="生产队">
        <el-input v-model="queryInfo.name" clearable placeholder="请输入"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="add('new')">新增</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    indexKey="编码"
    >
      <template #index/>
      <template #action={row}>
        <el-button type="text" size="small" @click="add('endUseCar', row)">编辑</el-button>
        <el-button type="text" size="small" @click="add('details', row)">查看详情</el-button>
      </template>
    </table-list>
    <details-dialog ref="details" @addSuccess="query"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import DetailsDialog from './details.vue'
import { teamQuery } from '@/api/community.js'
export default {
  data () {
    return {
      queryInfo: {
        town: '',
        village: '',
        name: ''
      },
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '镇', prop: 'town' },
        { label: '村', prop: 'village' },
        { label: '生产队', prop: 'name' },
        { label: '邮政编码', prop: 'postcode' },
        { label: '编辑日期', prop: 'modifiedTime' },
        { label: '操作', prop: 'action' }
      ],
      show: false
    }
  },
  components: {
    TableList,
    DetailsDialog
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    add (type = 'new', info = {}) {
      this.$refs.details.showDetails(type, info)
    },
    getData () {
      // this.loading = true
      teamQuery({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
  },
  mounted () {
    this.query()
  }
}
</script>